module.exports = __webpack_public_path__ + "static/media/bulkupload-success.f5fb3b5d.png";